import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	TableCell,
	TableRow,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import TableActions from "src/common/TableActions";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { IAccountData } from "src/Types/account.types";
import UpdateAccount from "./UpdateAccount";

type IProps = {
	account: IAccountData;
	serial: number;
};

const AccountTableRow = ({ account, serial }: IProps) => {
	const theme = useTheme();

	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const { mutate: deleteAccount } = useApiMutation<void, void>({
		endPoint: `/api/fair/admin/account/${account.ac_id}`,
		method: "DELETE",
		invalidateQueries: ["Accounts", "Account", account.ac_id],
	});

	return (
		<>
			<TableRow hover>
				<TableCell>{serial}</TableCell>
				<TableCell>
					<Typography variant='body1' color='text.primary' noWrap>
						{account.ac_bank_name}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography variant='body1' color='text.primary' noWrap>
						{account.ac_name}
					</Typography>
				</TableCell>
				<TableCell>{account.ac_type}</TableCell>
				<TableCell>{account.ac_number || "N/A"}</TableCell>
				<TableCell>{account.ac_bank_branch || "N/A"}</TableCell>
				<TableCell>{parseFloat(account.balance).toFixed(2)}</TableCell>

				<TableActions
					showView
					showEdit
					handleEditFun={handleOpen}
					showDelete
					handleDeleteFun={deleteAccount}
					viewLink={`details/${account.ac_id}`}
				/>
				{/* </TableCell> */}
			</TableRow>
			{/* Modal */}
			<Dialog
				fullScreen={fullScreen}
				open={open}
				maxWidth='md'
				onClose={handleClose}
				aria-labelledby='responsive-dialog-title'
			>
				<DialogContent>
					<Box sx={{ mb: 2 }}>
						<Typography sx={{ mb: 2 }}>
							Update Account: {account.ac_name}
						</Typography>
					</Box>
					<UpdateAccount
						id={account.ac_id}
						handleClose={handleClose}
					/>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default AccountTableRow;
